var _rect, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0237732,
    width: 32,
    height: 32,
    rx: 16,
    transform: "rotate(-0.042554 0 0.0237732)",
    fill: "white",
    fillOpacity: 0.06
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.15601 13.0411L7.64801 14.7295L5.15601 14.7295L5.15601 21.012L7.64801 21.012L7.64801 14.7295L7.64801 10.96L5.15601 10.96L5.15601 13.0411Z",
    fill: "url(#paint0_linear_1299_2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.026 13.4688C22.3773 13.4688 22.6504 13.7432 22.6504 14.096L22.6504 15.5464L25.148 17.232L25.148 13.4688C25.148 12.0968 24.0163 10.96 22.6504 10.96L7.70401 10.96L11.4504 13.4688L22.0651 13.4688L22.026 13.4688Z",
    fill: "url(#paint1_linear_1299_2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.522 18.5032C14.1707 18.5032 13.8976 18.2288 13.8976 17.876L13.8976 16.4256L11.4 14.74L11.4 18.5032C11.4 19.8752 12.5317 21.012 13.8976 21.012L28.844 21.012L25.0976 18.5032L14.4829 18.5032L14.522 18.5032Z",
    fill: "url(#paint2_linear_1299_2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1299_2",
    x1: 2.75176,
    y1: 15.9862,
    x2: 23.4912,
    y2: 15.9862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0091653,
    stopColor: "#AAACAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1095,
    stopColor: "#C9CACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#DFE0E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2859,
    stopColor: "#ECEDEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4681,
    stopColor: "#EAEBEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6561,
    stopColor: "#D7D8DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8892,
    stopColor: "#B8BABC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1299_2",
    x1: 2.89913,
    y1: 14.096,
    x2: 23.2527,
    y2: 14.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0091653,
    stopColor: "#AAACAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1095,
    stopColor: "#C9CACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#DFE0E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2859,
    stopColor: "#ECEDEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4681,
    stopColor: "#EAEBEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6561,
    stopColor: "#D7D8DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8892,
    stopColor: "#B8BABC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1299_2",
    x1: 3.03697,
    y1: 17.876,
    x2: 23.3905,
    y2: 17.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0091653,
    stopColor: "#AAACAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1095,
    stopColor: "#C9CACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#DFE0E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2859,
    stopColor: "#ECEDEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4681,
    stopColor: "#EAEBEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6561,
    stopColor: "#D7D8DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8892,
    stopColor: "#B8BABC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIo);
export default __webpack_public_path__ + "static/media/IO.991083b505145fce76ba8eaaf2333a22.svg";
export { ForwardRef as ReactComponent };